module.exports = __webpack_public_path__ + "static/media/banner.8dd491b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner.png
// module id = 737
// module chunks = 1